import {APIService} from '@/services/api.service';

export interface SurveyBackEndAnswer {
  description: string;
  id: string;
  question_id: string;
}

export enum SurveyQuestionCategory {
  RATING = 'RATING',
  OPTION = 'OPTION',
  TEXT = 'TEXT',
}

interface SurveyBackendQuestion {
  answers: SurveyBackEndAnswer[];
  category: SurveyQuestionCategory;
  description: string;
  id: string;
  survey_id: string;
  optional: boolean;
}

interface BackendSurvey {
  description: string;
  id: string;
  questions: SurveyBackendQuestion[];
}

interface SurveyBackendResponse {
  surveys: BackendSurvey[];
}

export async function getSurvey(userId: string): Promise<BackendSurvey[]> {
  try {
    const {surveys} = await APIService.get<SurveyBackendResponse>('survey/domain', {
      params: {
        user_id: userId,
        mode: process.env.VUE_APP_MODE,
      },
    });
    return surveys;
  } catch {
    return [];
  }
}

export async function saveSurvey(userId: string, surveyId: string, answers: SurveyBackEndAnswer[]): Promise<void> {
  try {
    await APIService.post(
      'survey/response',
      {user_id: userId, survey_id: surveyId, answers},
      {
        params: {
          user_id: userId,
          mode: process.env.VUE_APP_MODE,
        },
      },
    );
  } catch {}
}

export async function rejectSurvey(userId: string, surveyId: string, answers: SurveyBackEndAnswer[]): Promise<void> {
  try {
    return await APIService.post(
      'survey/response/skipped',
      {user_id: userId, survey_id: surveyId, answers},
      {
        params: {
          user_id: userId,
          survey_id: surveyId,
          mode: process.env.VUE_APP_MODE,
        },
      },
      true,
    );
  } catch {}
}
